// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7797a52c] .tabmenudemo-content {\n  padding: 2rem 1rem;\n}\n.vertical-line[data-v-7797a52c] {\n  border-left: 2px solid;\n  color: var(--text-color-secondary);\n}", ""]);
// Exports
module.exports = exports;
